import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { hideModal, selectActiveModalName, selectActiveModalProps } from 'redux/modules/modals';
import { decorateWith } from 'helpers/decorator';
import { AnnouncementsModal } from 'containers/Announcements/AnnouncementsModalContainer';
import { BillingTrustModal } from 'features/Purchase/components/BillingTrustModal';
import { CmsModal } from 'components/CmsModals/CmsModal';
import { SaveOfferModalContainer } from 'features/Settings/Membership/SaveOfferModalContainer';
import { ClassBundleModal } from 'features/Settings/Membership/Bundles/ClassBundleModal';
import { ContentModal } from 'components/ModalHost/ContentModal';
import { DeviceSetupModal } from 'containers/DeviceSetupModal/DeviceSetupModal';
import { InviteAFriendModalContainer as InviteAFriendModal } from 'components/Profile/InviteAFriendModal/InviteAFriendModalContainer';
import { Modal as LocationModal } from 'containers/LocationModal/Modal';
import { PlanConfirmationModalContainer as PlanConfirmationModal } from 'features/Settings/Membership/Plans/PlanConfirmationModalContainer';
import { ReactivationModalContainer as ReactivationModal } from 'features/Search/ReactivationModalContainer';
import { Modal as LegacyReservationModal } from 'components/Reservation/Modal';
import { LocaleModal } from 'components/LocaleSwitcher/LocaleModal';
import { ReviewsModal } from 'components/Explore/ReviewsModal';
import { ScheduleModal } from 'components/Explore/ScheduleModal';
import { CancelReservationModalContainer as CancelReservationModal } from 'features/Reservation/CancelReservationModal/CancelReservationModalContainer';
import { ReservationModalContainer as ReservationModal } from 'features/Reservation/ReservationModal/ReservationModalContainer';
import { UpdateProfileModal } from 'features/Reservation/UpdateProfileModal/UpdateProfileModal';
import { VideosRatingModalContainer as VideosRatingsModal } from 'features/Videos/VideosRatingModalContainer';
import { Modal as YouTubeVideoModal } from 'containers/YouTubeVideoModal/Modal';
var MODAL_COMPONENTS = {
  AnnouncementsModal: AnnouncementsModal,
  BillingTrustModal: BillingTrustModal,
  CancelReservationModal: CancelReservationModal,
  ClassBundleModal: ClassBundleModal,
  CmsModal: CmsModal,
  ContentModal: ContentModal,
  DeviceSetupModal: DeviceSetupModal,
  InviteAFriendModal: InviteAFriendModal,
  LegacyReservationModal: LegacyReservationModal,
  LocaleModal: LocaleModal,
  LocationModal: LocationModal,
  PlanConfirmationModal: PlanConfirmationModal,
  ReactivationModal: ReactivationModal,
  ReservationModal: ReservationModal,
  ReviewsModal: ReviewsModal,
  SaveOfferModal: SaveOfferModalContainer,
  ScheduleModal: ScheduleModal,
  UpdateProfileModal: UpdateProfileModal,
  VideosRatingsModal: VideosRatingsModal,
  YouTubeVideoModal: YouTubeVideoModal
};
export var mapStateToProps = function mapStateToProps(state) {
  return {
    modalName: selectActiveModalName(state),
    modalProps: selectActiveModalProps(state)
  };
};
export var mapDispatchToProps = {
  onHideRequest: hideModal
};
export var ModalHostUnwrapped =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ModalHostUnwrapped, _PureComponent);

  function ModalHostUnwrapped() {
    _classCallCheck(this, ModalHostUnwrapped);

    return _possibleConstructorReturn(this, _getPrototypeOf(ModalHostUnwrapped).apply(this, arguments));
  }

  _createClass(ModalHostUnwrapped, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          modalName = _this$props.modalName,
          modalProps = _this$props.modalProps,
          onHideRequest = _this$props.onHideRequest;

      if (modalName) {
        var ModalToRender = MODAL_COMPONENTS[modalName];

        if (!ModalToRender) {
          throw new Error("Cannot find modal ".concat(modalName));
        }

        return React.createElement(ModalToRender, _extends({
          onModalClose: function onModalClose() {
            return onHideRequest(modalName);
          }
        }, modalProps));
      }

      return false;
    }
  }]);

  return ModalHostUnwrapped;
}(PureComponent);
export var ModalHost = decorateWith(connect(mapStateToProps, mapDispatchToProps))(ModalHostUnwrapped);
ModalHostUnwrapped.propTypes = {
  modalName: PropTypes.string,
  modalProps: PropTypes.object,
  onHideRequest: PropTypes.func.isRequired
};